<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="终端标识:" prop="label">
          <Input v-model="formFields.label" placeholder="请输入终端标识..." size="small" />
        </FormItem>
        <FormItem label="终端序列号:" prop="serialNumber">
          <Input v-model="formFields.serialNumber" placeholder="请输入终端序列号..." size="small" />
        </FormItem>
        <!-- <FormItem label="终端地址:" prop="address">
          <Input v-model="formFields.address" placeholder="请输入终端IP地址..." size="small" />
        </FormItem> -->
        <FormItem label="终端备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注..." size="small" />
        </FormItem>
        <FormItem label="是否安有射频:" prop="hasRadio">
          <RadioGroup v-model="formFields.hasRadio">
            <Radio :label="1" :true-value="1">
              有
            </Radio>
            <Radio :label="0" :true-value="0">
              没有
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否启用:" prop="status">
          <RadioGroup v-model="formFields.status">
            <Radio :label="1" :true-value="1">
              启用
            </Radio>
            <Radio :label="0" :true-value="0">
              不启用
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" :disabled="loadingStatus" size="small" icon="ios-checkmark-circle-outline" :loading="submit" @click="saveOrUpdate">
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'ParkingAgentDialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    parkingId: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        label: '',
        serialNumber: '',
        remarks: '',
        status: 1,
        hasRadio: 1,
        id: this.id,
        parkingId: this.parkingId
      },
      ruleValidate: {
        label: [
          { required: true, message: '终端标识不能为空!', trigger: 'blur' }
        ]
        // address: [
        //   { required: true, message: '终端IP地址不合法!', pattern: /^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, trigger: 'blur' }
        // ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑车库终端' : '添加车库终端'
      }
    },
    action() {
      return this.$config.apiContextPath + '/parking/' + this.parkingId + '/agent'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          // this.formFields = res.data
          applyObject(res.data, this.formFields)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
      this.formFields.parkingId = 0
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            this.formFields.parkingId = this.parkingId
            request({
              url: this.action + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({
                title: '数据保存成功',
                desc: '车库终端 `' + this.formFields.label + '` 保存成功!'
              })
              this.submit = false
              this.closeModal(true)
            }).catch(() => {
              // this.$Notice.error({
              //   title: '服务器数据请求失败',
              //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
              // })
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
